module.exports = __webpack_public_path__ + "img/TechMarketTribute1_ua.24c547a3.webp";